module.exports = __webpack_public_path__ + "static/media/kdb-banner@2x.bafca55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdb-banner@2x.png
// module id = 1280
// module chunks = 1